import React, { useLayoutEffect, useMemo, useRef, useState } from "react";
import Tooltip from "../../CommonComponents/Tooltip";
import IconButton from "../../CommonComponents/IconButton";
import { useParams, useSearchParams } from "react-router-dom";
import { nanoid } from "nanoid";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import useAuth from "../../../Hooks/useAuth";
import { libTypeIds, BATCH_TYPE, RESULT_STATUS } from "../../../constants";
import Loading from "../../Notification-Loading/Loading/Loading";
import ReusableBreadcrumbs from "../../CommonComponents/ReusableBreadCrumbs";
import Modal from "../../CommonComponents/Modal";
import CreateModule from "./CreateModule";
import ChapterComponent from "./Chapter";
import Button from "../../Button";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Toast from "../../CommonComponents/Toast";
import ReactQuill from "react-quill";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";
import Publish from "./Publish";
import constants from "../../../constants";
const ITEM_TYPE = "CHAPTER";

const Chapter = ({
  item,
  moduleDetail,
  index,
  reorder,
  onDragStart,
  onDelete,
  onChange,
  onBlurDuedaysField,
  onAddChapterItem,
  onBlurField,
  onReorderChapterItem,
  onDeleteChapterItem,
  onUpdateItemSetting,
  onChangePublishData,
  onToggleChapter,
  isOpen,
  setToastMessage,
  setToastType,
  setToastOpen,
  isSharedLP,
}) => {
  const ref = useRef(null);

  const [, drop] = useDrop({
    type: ITEM_TYPE,
    accept: ITEM_TYPE,
    hover(dragItem, monitor) {
      if (!monitor.isOver({ shallow: true })) return;
      if (!ref.current) return;

      const dragIndex = dragItem.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) return;

      // moveModule(dragIndex, hoverIndex);
      // reorder(dragIndex, hoverIndex);

      // 🔑 keep index in sync
      dragItem.index = hoverIndex;
    },
    drop(dragItem) {
      if (dragItem.originalIndex !== dragItem.index) {
        // moveModule(dragItem.originalIndex, dragItem.index);
        reorder(dragItem.originalIndex, dragItem.index, true);
      }
    },
  });

  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: ITEM_TYPE,
      item: () => {
        onDragStart();
        return { index, originalIndex: index };
      },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [index],
  );

  drag(drop(ref));

  return (
    <ChapterComponent
      ref={ref}
      style={{ opacity: isDragging ? 0.5 : 1 }}
      key={item.moduleId}
      item={item}
      moduleDetail={moduleDetail}
      onDelete={onDelete}
      onChange={onChange}
      onAddChapterItem={onAddChapterItem}
      onBlurField={onBlurField}
      onBlurDuedaysField={onBlurDuedaysField}
      index={index}
      onReorderChapterItem={onReorderChapterItem}
      onDeleteItem={onDeleteChapterItem}
      onUpdateItemSetting={onUpdateItemSetting}
      onChangePublishData={onChangePublishData}
      onToggleChapter={onToggleChapter}
      isOpen={isOpen}
      setToastMessage={setToastMessage}
      setToastType={setToastType}
      setToastOpen={setToastOpen}
      isSharedLP={isSharedLP}
    />
  );
};

const ModuleDetails = () => {
  const { id = null, lpid, mid } = useParams();
  const { getCatchBlockDetails } = useCommonFunctionHooks();

  const [searchParams] = useSearchParams();
  const axios = useAxiosPrivate();
  const { setIsLoaded, setShowNotify, isLoaded, navigate, batchDetails } = useAuth();

  const baseRoute = id ? `/batches/${id}/courses` : "/learningpath";
  const openedChapter = searchParams.get("chapterId");

  const [details, setDetails] = useState({});
  const [moduleDetail, setModuleDetail] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState(false);
  const [toastType, setToastType] = useState("warning");
  const [openChapter, setOpenChapter] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [openPublishallModal, setOpenPublishallModal] = useState(false);

  console.log("details", details);
  console.log("moduleDetail", moduleDetail);

  const prevOrderRef = useRef([]);


  useLayoutEffect(() => {
    if (Number.isInteger(+lpid) && Number.isInteger(+mid)) fetchModuleDetails();
  }, [lpid, mid, axios, setIsLoaded, setShowNotify, openedChapter]);

  const fetchModuleDetails = async () => {
    try {
      setIsLoaded(true);
      const { data } = await axios.get(
        `node/admin/learningpath/${lpid}?moddata=true&mid=${mid}`,
      );
      if (data.resultCode === RESULT_STATUS.SUCCESS) {
        let response =
          typeof data.data === "string" ? JSON.parse(data.data) : data.data;
        setDetails(response);
        let copyResponse = response.modules[0] ?? {};
        copyResponse.chapters.forEach((chapter) => {
          chapter.status = "old";
          chapter.chapterData.forEach((item) => (item.status = "old"));
        });
        copyResponse.name = copyResponse.moduleName || "";
        copyResponse.description = copyResponse.moduleDesc || "";
        const targetChapterId =
          Number(openedChapter) || copyResponse.chapters[0]?.chapterId;
        setOpenChapter(
          copyResponse.chapters.reduce((acc, cur) => {
            acc[cur.chapterId] = cur.chapterId === targetChapterId;
            return acc;
          }, {}),
        );

        copyResponse.chapters.sort(
          (a, b) => a.chapterOrderno - b.chapterOrderno,
        );
        copyResponse.chapters = copyResponse.chapters.map((chapter) => {
          chapter.chapterData = chapter.chapterData.sort(
            (a, b) => a.orderno - b.orderno,
          );
          return chapter;
        });
        setModuleDetail(copyResponse);
      } else {
        setShowNotify({
          title: "Error !",
          msg:
            data.msg ?? `Unable to get the path list. Please try again later`,
          show: true,
        });
      }
    } catch (error) {
      console.error("error in fetch path details", error);
      let isUnAuth = error.message.includes("403");
      setShowNotify({
        isUnAuth,
        title: isUnAuth ? "Warning !" : "Error !",
        msg: isUnAuth
          ? "You have been logged-out due to inactivity. Login again."
          : `Unable to get the path list. Please try again later`,
        show: true,
      });
    } finally {
      setIsLoaded(false);
    }
  };

  console.log("chapteropen", openChapter);

  const items = useMemo(
    () => [
      {
        label: id ? "Curriculum" : "Learningpaths",
        href: id ? null : "/learningpath",
      },
      { label: `${details.name}`, href: `${baseRoute}/${lpid}` },
      { label: `${moduleDetail.moduleName}` },
    ],
    [id, details, moduleDetail, baseRoute, lpid],
  );

  const onUpdateModule = (res) => {
    console.log("moduleDetail in update", res);

    setDetails((prev) => ({
      ...prev,
      modules: prev.modules.map((module) => {
        if (module.moduleId === +mid) {
          module.moduleName = res.name;
          module.moduleDesc = res.description;
          module.name = res.name;
          module.description = res.description;
        }
        return module;
      }),
    }));
    setModuleDetail((prev) => ({
      ...prev,
      moduleName: res.name,
      moduleDesc: res.description,
    }));
  };

  const onAddChapter = () => {
    let copyChapters = structuredClone(moduleDetail.chapters);
    let lastChapter = copyChapters?.pop();
    const newchapter = {
      chapterId: nanoid(),
      chapterName: "",
      status: "new",
      chapterOrderno: lastChapter?.chapterOrderno ? (lastChapter.chapterOrderno) + 1000 : moduleDetail?.moduleOrderno + 1000,
      chapterData: [],
    };
    setModuleDetail((prev) => ({
      ...prev,
      chapters: [...prev.chapters, newchapter],
    }));
  };

  console.log("moduleDetail", moduleDetail);
  const isSelfPacedBatch =
    parseInt(sessionStorage.getItem("batchType"), 10) ===
    constants.BATCH_TYPE.SELF;
  const onChange = async (chapterId, field, value = "") => {
    setModuleDetail((prev) => ({
      ...prev,
      chapters: prev.chapters?.map((item) => {
        if (item.chapterId === chapterId) item[field] = value;
        return item;
      }),
    }));
  };

  const onBlurField = async (item = {}) => {
    try {
      console.log("item in onBlurField function:", item);
      setIsLoading(true);
      const isEdit = item.chapterId && item.status === "old";
      if (item.chapterName) {
        if (isEdit) {
          const { data } = await axios.put(
            `node/admin/module/${item.chapterId}?lpId=${lpid}`,
            {
              name: item.chapterName,
              description: item.chapterDescription,
              orderno: item.chapterOrderno,
              parentModId: item.moduleId,
              duedays: item.duedays,
              scope: "chapter",
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
          );
          if (data.resultCode === RESULT_STATUS.SUCCESS) {
            console.log("data", data);
            setToastOpen(true);
            setToastMessage(`The chapter is updated successfully`);
            setToastType("success");
          } else {
            setToastOpen(true);
            setToastMessage(
              `Unable to update the chapter. Please try again later`,
            );
            return;
          }
        } else {
          const { data } = await axios.post(
            `node/admin/module?lpId=${lpid}`,
            {
              name: item.chapterName,
              description: item.chapterDescription,
              orderno: item.chapterOrderno,
              parentModId: moduleDetail.moduleId,
              duedays: item.duedays,
              scope: "chapter",
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
          );
          if (data.resultCode === RESULT_STATUS.SUCCESS) {
            console.log("data", data);
            setModuleDetail((prev) => ({
              ...prev,
              chapters: prev.chapters?.map((chapter) => {
                if (chapter.chapterId === item.chapterId) {
                  chapter.chapterId = data.moduleId;
                  chapter.chapterOrderno = data.lpModuleOrderno;
                  chapter.status = "old";
                }
                return chapter;
              }),
            }));
            setToastOpen(true);
            setToastMessage(`The chapter is created successfully`);
            setToastType("success");
          } else {
            setToastOpen(true);
            setToastType("error");
            setToastMessage(
              `Unable to create the chapter. Please try again later`,
            );
            return;
          }
        }
      } else {
        setToastOpen(true);
        setToastType("error");
        setToastMessage(`The chapter name is required.`);
      }
    } catch (error) {
      let isUnAuth = error.message.includes("403");
      if (isUnAuth) {
        setShowNotify({
          isUnAuth,
          title: "Warning !",
          msg: "You have been logged-out due to inactivity. Login again.",
          show: true,
        });
        return;
      }
      setToastOpen(true);
      setToastMessage(
        error.message ?? `Unable to create the chapter. Please try again later`,
      );
      setToastType("error");
    } finally {
      setIsLoading(false);
    }
  };

  const onBlurDuedaysField = async (item = {}) => {
    try {
      if (!item.chapterName) {
        setToastOpen(true);
        setToastMessage("Chapter name is required");
        setToastType("warning");
        return;
      }
    } catch (error) {
      let isUnAuth = error.message.includes("403");
      setToastOpen(true);
      setToastMessage(
        isUnAuth
          ? "The session token is expired. Please logout and login again."
          : error.message ??
          `Unable to create the module. Please try again later`,
      );
    }
  };

  const onDeleteChapter = async (chapter) => {
    setModuleDetail((prev) => ({
      ...prev,
      chapters: prev.chapters?.filter(
        (item) => item.chapterId !== chapter.chapterId,
      ),
    }));
  };

  const onAddChapterItem = (chapterId, type = null, isSingleCc, isVideoqns) => {
    if (!chapterId) return;
    if (isSingleCc) {
      navigate(
        `library/${type}/questionlist?selectable=true&lpId=${lpid}&moduleId=${mid}&chapterId=${chapterId}${id ? `&bId=${id}` : ""
        }`,
      );
    } else if (isVideoqns) {
      navigate(
        `library/${type}/testlist?selectable=true&lpId=${lpid}&moduleId=${mid}&chapterId=${chapterId}&isVideoInterview=${isVideoqns}${id ? `&bId=${id}` : ""
        }`,
      );
    } else
      navigate(
        `library/${type}/testlist?selectable=true&lpId=${lpid}&moduleId=${mid}${type == libTypeIds.DESCRIPTIVE ? "&isVideoInterview=false" : ""}&chapterId=${chapterId}${id ? `&bId=${id}` : ""
        }`,
      );
  };

  const onToggleChapter = (chapterId) => {
    setOpenChapter((prev) => ({
      ...prev,
      [chapterId]: !prev[chapterId],
    }));
  };

  const reorderChapters = async (from, to, canCallApi = false) => {
    console.log("from", from, "to", to, "moduleDetail", moduleDetail);

    if (details.isSharedLP === 1) {
      return (
        setToastOpen(true),
        setToastMessage("Reorder is not allowed in shared learning path."),
        setToastType("error")
      );
    }

    if (from === to) return;

    const copyModuleDetails = structuredClone(moduleDetail);
    const chapters = [...copyModuleDetails.chapters];
    let minOrderno = chapters[0]?.chapterOrderno || 1;
    const presentId = chapters[to]?.chapterId;

    const [movedItem] = chapters.splice(from, 1);
    const movingId = movedItem.chapterId;

    console.log("movedItem", movedItem);

    chapters.splice(to, 0, movedItem);

    const topId = chapters[to - 1]?.chapterId ?? null;
    const bottomId = chapters[to + 1]?.chapterId ?? null;
    console.log("chapters", chapters);

    // const updatedChapters = chapters.map((chapter, index) => ({
    //   ...chapter,
    //   chapterOrderno: minOrderno++,
    // }));

    // const payload = updatedChapters.map((c) => ({
    //   moduleId: c.chapterId,
    //   orderno: c.chapterOrderno,
    // }));

    setModuleDetail((prev) => ({
      ...prev,
      chapters: chapters,
    }));
    if (canCallApi) {
      try {
        setIsLoading(true);
        const { data } = await axios.post(
          `node/admin/learningpath/${lpid}/reorder-modules`,
          {
            // modules: payload,
            lpId: lpid,
            scope: "chapter",
            topId: topId,
            bottomId: bottomId,
            moduleId: movingId,
            targetParentId: presentId, // change after wards
            parentModId:mid
          },
        );
        if (data.resultCode !== RESULT_STATUS.SUCCESS) {
          throw new Error(
            data.msg ?? `Unable to reorder chapter. Please try again later`,
          );
        } else {
          setToastMessage("Chapter reordered successfully.");
          setToastType("success");
          setToastOpen(true);
        }
      } catch (error) {
        console.log("error in reorder module", error);

        setModuleDetail((prev) => ({
          ...prev,
          chapters: prevOrderRef.current,
        }));
        let isUnAuth = error.message.includes("403");
        setShowNotify({
          isUnAuth,
          title: isUnAuth ? "Warning !" : "Error !",
          msg: isUnAuth
            ? "You have been logged-out due to inactivity. Login again."
            : `Unable to reorder chapter. Please try again later`,
          show: true,
        });
      } finally {
        setIsLoading(false);
      }
    }
  };

  const onReorderChapterItem = (moduleId, chapterId, reorderedData) => {
    setModuleDetail((prev) => {
      const chapters = [...prev.chapters];
      const chapter = chapters.find(
        (chapter) => chapter.chapterId === +chapterId,
      );
      chapter.chapterData = reorderedData;

      return {
        ...prev,
        chapters: chapters,
      };
    });
  };

  const onUpdateItemSetting = (chapterId, lpcId, field, value) => {
    setModuleDetail((prev) => {
      return {
        ...prev,
        chapters: prev.chapters.map((chapter) => {
          if (chapter.chapterId !== +chapterId) return chapter;

          return {
            ...chapter,
            chapterData: chapter.chapterData.map((item) =>
              item.lpcId === lpcId ? { ...item, [field]: value } : item,
            ),
          };
        }),
      };
    });
  };

  const onDeleteChapterItem = async (chapterId, item = {}) => {
    console.log("chapterId", chapterId, "item", item);

    setModuleDetail((prev) => {
      const chapters = [...prev.chapters];
      const chapter = chapters.find(
        (chapter) => chapter.chapterId === +chapterId,
      );
      if (chapter)
        chapter.chapterData = chapter.chapterData.filter(
          (cItem) => cItem.lpcId !== item.lpcId,
        );

      return {
        ...prev,
        chapters: chapters,
      };
    });
  };

  const onChangePublishData = (chapterId, lpcId, data) => {
    setModuleDetail((prev) => {
      return {
        ...prev,
        chapters: prev.chapters.map((chapter) => {
          if (chapter.chapterId !== +chapterId) return chapter;

          return {
            ...chapter,
            chapterData: chapter.chapterData.map((item) =>
              item.lpcId === lpcId ? data : item,
            ),
          };
        }),
      };
    });
  };

  // const onChangePublishAllData = (chapterId, lpcId) => {
  //   setModuleDetail((prev) => {
  //     return {
  //       ...prev,
  //       chapters: prev.chapters.map((chapter) => {
  //         if (chapter.chapterId !== +chapterId) return chapter;

  //         return {
  //           ...chapter,
  //           chapterData: chapter.chapterData.map((item) =>
  //             item.lpcId === lpcId ? ({ ...item, published: 1 }) : item,
  //           ),
  //         };
  //       }),
  //     };
  //   });
  // };

  // const onChangePublishAllData = (chapterId, lpcIds) => {
  //   const lpcSet = new Set(lpcIds.map(Number));
  //   const chapterIds = moduleDetail.chapters.forEach((chapter)=>{
  //     chapter.chapterId
  //   })
  //   setModuleDetail((prev) => ({
  //     ...prev,

  //     chapters: prev.chapters.map((chapter) => {
  //       if (chapter.chapterId !== Number(chapterId)) {
  //         return chapter;
  //       }

  //       return {
  //         ...chapter,

  //         chapterData: chapter.chapterData.map((item) =>
  //           lpcSet.has(Number(item.lpcId))
  //             ? { ...item, published: 1 }
  //             : item
  //         ),
  //       };
  //     }),
  //   }));
  // };

  // const onChangePublishAllData = () => {
  //   const publishMap = new Map();
  //   // create map -> chapterId => Set(lpcIds)
  //   moduleDetail.chapters.forEach((chapter) => {
  //     publishMap.set(
  //       Number(chapter.chapterId),
  //       new Set(
  //         chapter.chapterData.map((item) => Number(item.lpcId))
  //       )
  //     );
  //   });

  //   setModuleDetail((prev) => ({
  //     ...prev,

  //     chapters: prev.chapters.map((chapter) => {
  //       const lpcSet = publishMap.get(Number(chapter.chapterId));

  //       if (!lpcSet) return chapter;

  //       return {
  //         ...chapter,

  //         chapterData: chapter.chapterData.map((item) =>
  //           lpcSet.has(Number(item.lpcId))
  //             ? { ...item, published: 1 }
  //             : item
  //         ),
  //       };
  //     }),
  //   }));
  // };

  const onClickBack = () => {
    navigate(`${baseRoute}/${lpid}`);
  };

  const onClickPublishAll = async (dueDate) => {
    let isPublish = openPublishallModal;
    try {
      const response = await axios.put(`node/admin/learningpath/${lpid}/module/${mid}/publish`, {
        dueDate: dueDate,
        scope: "publish",
        bId: id
      });
      console.log("response:", response);
      if (response.data.resultCode === RESULT_STATUS.SUCCESS) {
        setOpenPublishallModal(false);
        // setOpenDuedateModal(false);
        setToastType("success");
        setToastMessage(
          isPublish
            ? `The test is published successfully.`
            : "The duedate updated successfully.",
        );
        setToastOpen(true);
      }
      else {
        throw new Error(response.data.msg ?? "Something went Wrong")
      }
    } catch (error) {
      console.log("error in publish all:", error);
      // getCatchBlockDetails(error);
      // setOpenDuedateModal(false);
      let isUnAuth = error.message.includes("403");
      if (isUnAuth) {
        setShowNotify({
          isUnAuth,
          title: "Warning !",
          msg: "You have been logged-out due to inactivity. Login again.",
          show: true,
        });
      }
      else {
        setOpenPublishallModal(false);
        setToastType("error");
        setToastMessage(
          isPublish
            ? error.message
              ? error.message
              : `Unable to publish the test. Please try again later.`
            : "Unable to update the duedate. Please try again later.",
        );
        setToastOpen(true);
      }
    }
    finally {
      if (Number.isInteger(+lpid) && Number.isInteger(+mid)) fetchModuleDetails();
    }
  }

  if (isLoaded) return <Loading />;

  return (
    <div
      className={`admin-path-module-details-container${id ? " admin-batch-path-module-details-container" : ""
        }`}
    >
      <ReusableBreadcrumbs items={items} />
      <div
        className={`admin-path-module-detail-back-btn-wrapper`}
        onClick={onClickBack}
      >
        <svg
          width="7"
          height="12"
          viewBox="0 0 7 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.7998 10.8L0.799805 5.80005L5.7998 0.800049"
            stroke="#667085"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <p className="admin-path-module-detail-back-btn-text">Back</p>
      </div>
      <div className="admin-path-module-details-info-wrapper">
        <div className="admin-path-module-details-info">
          <h2 className="admin-path-module-details-name">
            {moduleDetail.moduleName}
          </h2>
          {details.isSharedLP === 0 && (
            <Tooltip title="Edit info" isIcon={true}>
              <IconButton
                size="sm"
                hierarchy="tertiaryGrey"
                onClick={() => setOpenModal(true)}
              >
                <svg
                  width="19"
                  height="19"
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.33496 2.60273H4.83496C3.43483 2.60273 2.73476 2.60273 2.19998 2.87521C1.72958 3.1149 1.34713 3.49735 1.10744 3.96775C0.834961 4.50253 0.834961 5.2026 0.834961 6.60273V13.6027C0.834961 15.0029 0.834961 15.7029 1.10744 16.2377C1.34713 16.7081 1.72958 17.0906 2.19998 17.3302C2.73476 17.6027 3.43483 17.6027 4.83496 17.6027H11.835C13.2351 17.6027 13.9352 17.6027 14.4699 17.3302C14.9403 17.0906 15.3228 16.7081 15.5625 16.2377C15.835 15.7029 15.835 15.0029 15.835 13.6027V10.1027M5.83494 12.6027H7.23039C7.63804 12.6027 7.84187 12.6027 8.03368 12.5567C8.20374 12.5159 8.36632 12.4485 8.51544 12.3571C8.68363 12.2541 8.82776 12.1099 9.11601 11.8217L17.085 3.85273C17.7753 3.16237 17.7753 2.04308 17.085 1.35273C16.3946 0.662373 15.2753 0.662372 14.585 1.35273L6.61599 9.32168C6.32774 9.60993 6.18361 9.75406 6.08054 9.92225C5.98916 10.0714 5.92182 10.2339 5.88099 10.404C5.83494 10.5958 5.83494 10.7996 5.83494 11.2073V12.6027Z"
                    stroke="#344054"
                    strokeWidth="1.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton>
            </Tooltip>
          )}
        </div>
        {moduleDetail.moduleDesc && (
          <ReactQuill
            className="admin-path-module-details-description"
            readOnly={true}
            value={moduleDetail.moduleDesc}
          />
        )}
      </div>
      <div className="admin-path-module-details-chapters-header-wrapper">
        <h3 className="admin-path-module-details-chapters-header">Chapters</h3>
        <div className="admin-path-module-details-chapters-button wrapper">
          {
            id && moduleDetail && moduleDetail?.chapters?.length >= 1 && (
              <Button
                size="sm"
                hierarchy={{ type: "primary", buttonText: "Publish All" }}
                className="admin-path-module-details-chapter-publish-btn"
                onClick={() => {
                  setOpenPublishallModal(true);
                }}
              />
            )
          }
          {details.isSharedLP === 0 && (
            <Button
              size="sm"
              hierarchy={{ type: "secondaryGrey", buttonText: "Chapter" }}
              className="admin-path-module-details-chapter-add-btn"
              icon={{
                icon: (
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.66829 0.834961V12.5016M0.834961 6.66829H12.5016"
                      stroke="#344054"
                      strokeWidth="1.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ),
                type: "leading",
              }}
              onClick={onAddChapter}
            />
          )}
        </div>
      </div>
      <DndProvider backend={HTML5Backend}>
        <div className="admin-path-module-details-chapters-wrapper">
          <div className="admin-path-module-details-chapters-container">
            {moduleDetail.chapters?.map((chapter, index) => (
              <Chapter
                key={chapter.chapterId}
                item={chapter}
                moduleDetail={moduleDetail}
                index={index}
                onDelete={onDeleteChapter}
                onToggleChapter={onToggleChapter}
                onChange={onChange}
                onAddChapterItem={onAddChapterItem}
                onDragStart={() => {
                  prevOrderRef.current = moduleDetail.chapters;
                }}
                reorder={reorderChapters}
                onBlurField={onBlurField}
                onBlurDuedaysField={onBlurDuedaysField}
                onReorderChapterItem={onReorderChapterItem}
                onDeleteChapterItem={onDeleteChapterItem}
                onUpdateItemSetting={onUpdateItemSetting}
                onChangePublishData={onChangePublishData}
                isOpen={openChapter[chapter.chapterId]}
                setToastMessage={setToastMessage}
                setToastType={setToastType}
                setToastOpen={setToastOpen}
                isSharedLP={details.isSharedLP}
              />
            ))}
          </div>
        </div>
      </DndProvider>
      <Modal
        className="admin-path-module-form-modal"
        title="Module"
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
      >
        <CreateModule
          setOpenModal={setOpenModal}
          lpId={lpid}
          orderno={moduleDetail.moduleOrderno}
          onUpdate={onUpdateModule}
          moduleDetail={moduleDetail}
          setModuleDetail={setModuleDetail}
        />
      </Modal>

      {/* publish all modal */}
      <Modal
        isOpen={openPublishallModal}
        onClose={() => setOpenPublishallModal(false)}
        title={
          <div className="admin-path-module-chapter-detail-publish-all-modal-title-wrapper">
            <h4 className="admin-path-module-chapter-detail-publish-all-modal-title">
              Publish the test
            </h4>
            <p className="admin-path-module-chapter-detail-publish-all-modal-caption">
              Select when and how you would like to publish the test
            </p>
          </div>
        }
        className="admin-path-module-chapter-detail-publish-all-modal"
      >
        <Publish
          onSave={onClickPublishAll}
          batchType={batchDetails.batchtype || BATCH_TYPE.LEARNING}
          onCancel={() => setOpenPublishallModal(false)}
          from={"publishall"}
        />
      </Modal>
      {isLoading && <Loading />}
      <Toast
        open={toastOpen}
        type={toastType}
        message={toastMessage}
        onClose={() => setToastOpen(false)}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
    </div>
  );
};

export default ModuleDetails;
